import {
  Button,
  Icon,
} from "@twinkltech/curriculum-architect-component-library";
import { useId } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import { links } from "@/links";

import { APP_HEADER_NS } from "../../AppHeader.i18n";

export const AccountActionMenu = () => {
  const { t } = useTranslation(APP_HEADER_NS);
  const triggerLabelId = useId();
  return (
    <Button
      aria-labelledby={triggerLabelId}
      as={Link}
      target="_blank"
      to={links.TWINKL_ACCOUNT}
      variant="ghost"
    >
      <span className="mr-2" id={triggerLabelId}>
        {t("a11y.my-account-link.label")}
      </span>

      <Icon icon="AccountCircle" size="medium" />
    </Button>
  );
};
